<template>
  <div>
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <div>
        <Breadcrumbs
          data="classData.title"
          headline="Danh sách môn học"
          :link="[{ text: 'Danh sách môn học', href: '../courses' }]"
        />
      </div>
      <course-list-actions :selected="selected" v-if="canEdit" />
    </div>
    <v-card class="pa-2 mx-md-2">
      <v-data-table
        item-key="id"
        v-model="selected"
        :headers="headers"
        :items="courses"
        :search="search"
        dense
        disabled-sortable
        :show-select="!$vuetify.breakpoint.smAndDown && canEdit"
      >
        <div slot="top" class="d-flex flex-row justify-end align-end">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Tìm kiếm"
            single-line
            clearable
            hide-details
            dense
            filled
            class="flex-grow-0 align-end ma-2"
          ></v-text-field>
        </div>
        <template v-slot:[`item.title`]="{ item }">
          <router-link style="text-decoration: none" :to="'/course/' + item.id"
            ><div class="my-2">{{ item.title }}</div></router-link
          >
        </template>
        <template v-slot:[`item.majors`]="{ item }">
          <router-link
            style="text-decoration: none"
            :to="'/major/' + major.id"
            v-for="major in item.majors"
            :key="major.id"
            >{{ major.title }}</router-link
          >
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import CourseListActions from '@/modules/course/CourseListActions'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
export default {
  components: {
    CourseListActions,
    Breadcrumbs
  },
  props: {
    role: String
  },
  data() {
    return {
      headers: [
        { text: 'Tên', value: 'title', align: 'left', sortable: false },
        { text: 'Mã Môn Học', value: 'code', align: 'left', sortable: true },
        {
          text: 'Chuyên Ngành',
          value: 'majors',
          align: 'left',
          sortable: false
        },
        {
          text: 'Mô Tả Khóa Học',
          value: 'description',
          align: 'left',
          sortable: false
        }
      ],
      selected: [],
      draw: false,
      search: ''
    }
  },
  async created() {
    await this.fetchCourses({ department: this.department.id })
  },
  computed: {
    ...mapGetters('course', ['courses', 'count', 'course']),
    ...mapState('app', ['department']),
    ...mapState('auth', ['profile', 'role']),
    canEdit() {
      return ['super_admin', 'education_manager'].includes(this.role.type)
    }
  },
  methods: {
    ...mapActions('course', ['fetchCourses', 'fetchCoursesCount', 'setCourse', 'setCourses']),
    updateDraw(draw) {
      this.draw = draw
    },
    async preview(user) {
      if (!user) return
      this.$refs.template.preview()
      this.previewUserId = user.id
    },
    onCourseSelected(course) {
      this.setCourse(course)
      this.draw = true
    },
    getColor(status) {
      if (status === 'active') return 'green'
      else return 'red'
    },
    refresh(query) {
      this.setCourses([])
      this.fetchCourses({ department: this.department.id })
    }
  },
  filter: {
    minifyDescription(des) {
      if (des.length > 20) return des.substring(0, 20)
      return des
    },
    getMajor(major) {
      return major.title
    }
  }
}
</script>
